// @flow

import { toASCII } from 'punycode.js';

import { selectPricingInfos } from '@gandi/billing';

import type { FetchResponse } from '@gandi/resource/redux';

import { GET } from 'gandi.redux-fetcher';

import type { Dispatch, GetState } from '../../types';

export const fetchAvailability =
  (fqdn: string): ((dispatch: Dispatch, getState: GetState) => any) =>
  (dispatch: Dispatch, getState: GetState) => {
    const pricingInfos = selectPricingInfos(getState());

    const params = {
      ...pricingInfos,
      search: toASCII(fqdn),
    };

    return dispatch(
      GET('/suggest/lookup', {
        params,
        on200: (response: FetchResponse<>) => response,
        not200: (response: FetchResponse<>) => response,
      }),
    ).catch(() => {
      /* pass */
    });
  };
